/**
 * 这个文件作为组件的目录
 * 目的是统一管理对外输出的组件，方便分类
 */
/**
 * 布局组件
 */

import AssetImageUpload from './AssetImageUpload';
import BenefitTagSelect from './BenefitTagSelect';
import CodePreviewButton from './CodePreviewButton';
import DictionaryDisplay from './DictionaryDisplay';
import DictionaryForm from './DictionaryForm';
import DictionarySelect from './DictionarySelect';
import DictionaryTags from './DictionaryTags';
import DisplayTextMissingBadge from './DisplayTextMissingBadge';
import DisplayTextPreviewButton from './DisplayTextPreviewButton';
import Footer from './Footer';
import GoogleMapLocationPicker from './GoogleMapLocationPicker';
import LazyGoogleMapLocationPicker from './GoogleMapLocationPicker/LazyGoogleMapLocationPicker';
import ProFileUpload from './ProFileUpload';
import ProTable from './ProTable';
import RegionDisplay from './RegionDisplay';
import RegionSelect from './RegionSelect';
import { Question, SelectLang } from './RightContent';
import { AvatarDropdown, AvatarName } from './RightContent/AvatarDropdown';
import StaffSelector from './StaffSelector';

export {
  AssetImageUpload,
  AvatarDropdown,
  AvatarName,
  BenefitTagSelect,
  CodePreviewButton,
  DictionaryDisplay,
  DictionaryForm,
  DictionarySelect,
  DictionaryTags,
  DisplayTextMissingBadge,
  DisplayTextPreviewButton,
  Footer,
  GoogleMapLocationPicker,
  LazyGoogleMapLocationPicker,
  ProFileUpload,
  ProTable,
  Question,
  RegionDisplay,
  RegionSelect,
  SelectLang,
  StaffSelector,
};
